/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyMetadataLLMDto
 */
export interface CompanyMetadataLLMDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyMetadataLLMDto
     */
    companyId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyMetadataLLMDto
     */
    descriptionEN?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyMetadataLLMDto
     */
    descriptionNL?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyMetadataLLMDto
     */
    categoryEN?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyMetadataLLMDto
     */
    categoryNL?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CompanyMetadataLLMDto
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the CompanyMetadataLLMDto interface.
 */
export function instanceOfCompanyMetadataLLMDto(value: object): value is CompanyMetadataLLMDto {
    return true;
}

export function CompanyMetadataLLMDtoFromJSON(json: any): CompanyMetadataLLMDto {
    return CompanyMetadataLLMDtoFromJSONTyped(json, false);
}

export function CompanyMetadataLLMDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyMetadataLLMDto {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'descriptionEN': json['descriptionEN'] == null ? undefined : json['descriptionEN'],
        'descriptionNL': json['descriptionNL'] == null ? undefined : json['descriptionNL'],
        'categoryEN': json['categoryEN'] == null ? undefined : json['categoryEN'],
        'categoryNL': json['categoryNL'] == null ? undefined : json['categoryNL'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function CompanyMetadataLLMDtoToJSON(json: any): CompanyMetadataLLMDto {
    return CompanyMetadataLLMDtoToJSONTyped(json, false);
}

export function CompanyMetadataLLMDtoToJSONTyped(value?: CompanyMetadataLLMDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'descriptionEN': value['descriptionEN'],
        'descriptionNL': value['descriptionNL'],
        'categoryEN': value['categoryEN'],
        'categoryNL': value['categoryNL'],
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

